/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * Responds whether or not the Window object supports the Window Segments Enumeration API.
 *
 * @export
 * @returns {boolean}
 */
export function isWindowSegmentAware() {
    return window.getWindowSegments !== undefined;
}
/**
 * Returns an ISegmentAwareWindow instance of the Window object, or null if the API is not supported.
 *
 * @export
 * @returns {ISegmentAwareWindow}
 */
export function getSegmentAwareWindow() {
    return isWindowSegmentAware() ? window : null;
}
//# sourceMappingURL=WindowSegmentHelpers.js.map